<mat-toolbar class="mat-elevation-z4">
  <span fxFlex>Justificar Guardias</span>
</mat-toolbar>

<p-table
  #table
  responsiveLayout="scroll"
  lazy="true"
  [rows]="20"
  (onLazyLoad)="onLazyLoad($event)"
  [paginator]="true"
  [totalRecords]="totalElements"
  [value]="rows"
  dataKey="id"
  sortField="start"
  [sortOrder]="-1"
  tableStyleClass="mat-elevation-z4 size-s">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 40px"></th>

      <th pSortableColumn="lawyer.lastName">
        <p-sortIcon field="lawyer.lastName"></p-sortIcon>
        Abogado

        <p-columnFilter
          type="text"
          display="menu"
          field="lawyerName">
        </p-columnFilter>
      </th>

      <th pSortableColumn="start">
        <p-sortIcon field="start"></p-sortIcon>
        Fecha

        <p-columnFilter
          type="date"
          display="menu"
          field="start">
        </p-columnFilter>
      </th>

      <th pSortableColumn="judicialDistrict.name">
        <p-sortIcon field="judicialDistrict.name"></p-sortIcon>
        Partido Judicial

        <p-columnFilter
          field="judicialDistrict.id"
          matchMode="contains"
          display="menu"
          [showMatchModes]="false"
          [showOperator]="false"
          [showAddButton]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-multiSelect
              [ngModel]="value"
              [options]="filters?.judicialDistricts"
              (onChange)="filter($event.value)"
              optionValue="id"
              optionLabel="name">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>

      <th pSortableColumn="alias.name">
        <p-sortIcon field="alias.name"></p-sortIcon>
        Materia

        <p-columnFilter
          field="alias.id"
          matchMode="contains"
          display="menu"
          [showMatchModes]="false"
          [showOperator]="false"
          [showAddButton]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-multiSelect
              [ngModel]="value"
              [options]="filters?.alertsType"
              (onChange)="filter($event.value)"
              optionValue="id"
              optionLabel="name">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>

      <th pSortableColumn="justificationStatus" style="width: 60px">
        <p-sortIcon field="justificationStatus"></p-sortIcon>
        Estado

        <p-columnFilter
          field="justificationStatus"
          matchMode="contains"
          display="menu"
          [showMatchModes]="false"
          [showOperator]="false"
          [showAddButton]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-multiSelect
              [ngModel]="value"
              [options]="justificationStatusOptions"
              (onChange)="onJustificationStatusFilter($event.value); filter($event.value)"
              optionValue="value"
              optionLabel="label"
              [filter]="false">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>

      <th style="width: 48px"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      <td>
        <button
          *ngIf="getShiftAlerts(row.id).length > 0"
          mat-icon-button
          (click)="toggleExpand(row.id)"
          [matTooltip]="expandedShiftId === row.id ? 'Ocultar avisos' : 'Ver avisos vinculados'">
          <mat-icon>{{ expandedShiftId === row.id ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </td>

      <td class="sort-padding">
        {{ row.lawyerName }}
      </td>

      <td class="sort-padding">
        {{ row.date | date: 'dd/MM/yy HH:mm' }}
      </td>

      <td class="sort-padding">
        {{ row.judicialDistrict }}
      </td>

      <td class="sort-padding">
        {{ row.matter }}
      </td>

      <td>
        <mat-icon
          [svgIcon]="justificationStatusIcon(row.justificationStatus)"
          [ngClass]="justificationStatusColor(row.justificationStatus)"
          [matTooltip]="getJustificationTooltip(row.justificationStatus, row.rejectionReason)">
        </mat-icon>
      </td>

      <td>
        <button mat-icon-button [matMenuTriggerFor]="shiftMenu">
          <mat-icon svgIcon="dots-vertical"></mat-icon>
        </button>
        <mat-menu #shiftMenu="matMenu">
          <button
            mat-menu-item
            *ngIf="row.justificationStatus !== 'ACCEPTED'"
            (click)="approveShift(row)">
            <mat-icon svgIcon="check-circle-outline"></mat-icon>
            <span>Aceptar</span>
          </button>

          <button
            mat-menu-item
            *ngIf="row.justificationStatus !== 'REJECTED'"
            (click)="rejectShift(row)">
            <mat-icon svgIcon="close-circle-outline"></mat-icon>
            <span>Rechazar</span>
          </button>
        </mat-menu>
      </td>
    </tr>

    <tr *ngIf="expandedShiftId === row.id">
      <td colspan="7" style="padding: 0 16px 16px 40px;">
        <table class="alert-sub-table mat-elevation-z2" style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="padding: 8px; text-align: left; font-size: 0.85em;">Materia</th>
              <th style="padding: 8px; text-align: left; font-size: 0.85em;">Fecha</th>
              <th style="padding: 8px; text-align: left; font-size: 0.85em; width: 60px;">Estado</th>
              <th style="padding: 8px; width: 48px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let alertRow of getShiftAlerts(row.id)" style="border-top: 1px solid #e0e0e0;">
              <td style="padding: 6px 8px; font-size: 0.9em;">{{ alertRow.alertType }}</td>
              <td style="padding: 6px 8px; font-size: 0.9em;">{{ alertRow.date | date: 'dd/MM/yy HH:mm' }}</td>
              <td style="padding: 6px 8px;">
                <mat-icon
                  [svgIcon]="justificationStatusIcon(alertRow.justificationStatus)"
                  [ngClass]="justificationStatusColor(alertRow.justificationStatus)"
                  [matTooltip]="getJustificationTooltip(alertRow.justificationStatus, alertRow.rejectionReason)">
                </mat-icon>
              </td>
              <td style="padding: 6px 8px;">
                <button mat-icon-button [matMenuTriggerFor]="alertMenu">
                  <mat-icon svgIcon="dots-vertical"></mat-icon>
                </button>
                <mat-menu #alertMenu="matMenu">
                  <button
                    mat-menu-item
                    *ngIf="alertRow.justificationStatus !== 'ACCEPTED'"
                    (click)="approveAlertCall(alertRow)">
                    <mat-icon svgIcon="check-circle-outline"></mat-icon>
                    <span>Justificar</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="alertRow.justificationStatus !== 'REJECTED'"
                    (click)="rejectAlertCall(alertRow)">
                    <mat-icon svgIcon="close-circle-outline"></mat-icon>
                    <span>Rechazar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </ng-template>
</p-table>
